/**
 * Makes the input safe to use as a field name
 * @param input the string to sanitize
 * @returns a sanitized version of the input string (lowercase, underscores instead of spaces, no special characters)
 */
export function sanitizeName(input: string): string {
  if (!input) return input;

  return input
      .toLowerCase()
      .replace(/\s+/g, "_")
      .replace(/[^\w]/g, "");
}

function hashString(str) {
  let hash = 2166136261;

  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i);
    hash +=
      (hash << 1) +
      (hash << 4) +
      (hash << 7) +
      (hash << 8) +
      (hash << 24);
  }

  return hash >>> 0;
}

/**
 * Given any string, generates a random pastel hsl(...) color string.
 * @param str 
 * @returns 
 */
export function stringToColor(str) {
  const hash = hashString(str);

  const hue = hash % 360;

  // Pastel ranges
  const saturation = 40 + (hash % 20); // 40–60%
  const lightness = 82 + ((hash >> 8) % 10); // 82–92%

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}
